// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--34VY2","title":"styles-module--title--2affq","pillContainer":"styles-module--pillContainer--pu2nR","label":"styles-module--label--2CaPS"};